<a *ngIf="(canEdit$ | async)" class="calendar__icon-link" (click)="addEvent()">
  <div class="calendar__icon-wrapper">
    <mat-icon svgIcon="plus"></mat-icon>
  </div>
  Add Event
</a>
